import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPaperPlane,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";

export default function InquiryCard() {
  const { getCurrentAgentNumber, getCurrentAgentEmail } = useUserParams();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    setLoading(true);

    try {
      console.log(formData);

      setFormData({
        name: "",
        email: "",
        message: "",
      });

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="overflow-hidden border border-[#8b8172]/30 bg-white shadow-2xl">
      {/* Header */}
      <div className="bg-[#8b8172]/30 px-8 py-10">
        <div className="flex items-center gap-5">
          <div className="flex h-16 w-16 items-center justify-center bg-[#2b2925]">
            <FontAwesomeIcon
              icon={faEnvelope}
              className="text-2xl text-[#6d655b]"
            />
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.45em] text-[#6d655b]">
              Property Inquiry
            </p>

            <h3 className="mt-3 font-serif text-4xl leading-none text-[#2b2925]">
              Contact Agent
            </h3>
          </div>
        </div>

        <div className="mt-7 h-[1px] w-16 bg-[#6d655b]" />

        <p className="mt-6 text-sm leading-7 text-[#6d655b]">
          Interested in this property? Send a message and receive detailed
          information directly from our real estate team.
        </p>
      </div>

      {/* Form */}
      <form
        onSubmit={handleSubmit}
        className="space-y-6 bg-white p-8"
      >
        <div>
          <label className="mb-2 block text-xs uppercase tracking-[0.3em] text-[#2b2925]">
            Name
          </label>

          <input
            required
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your name"
            className="h-14 w-full border border-[#8b8172]/30 p-3 bg-[#fffdfa] text-[#2b2925] outline-none focus:border-[#8b8172]"
          />
        </div>

        <div>
          <label className="mb-2 block text-xs uppercase tracking-[0.3em] text-[#2b2925]">
            Email
          </label>

          <input
            required
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email address"
            className="h-14 w-full border border-[#8b8172]/30 p-3 bg-[#fffdfa] text-[#2b2925] outline-none focus:border-[#8b8172]"
          />
        </div>

        <div>
          <label className="mb-2 block text-xs uppercase tracking-[0.3em] text-[#2b2925]">
            Message
          </label>

          <textarea
            required
            rows="4"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="I am interested in this property..."
            className="h-32 w-full border border-[#8b8172]/30 p-3 bg-[#fffdfa] text-[#2b2925] outline-none focus:border-[#8b8172]"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full border border-black px-10 py-4 text-xs uppercase tracking-[0.35em] text-black transition-all duration-300 hover:bg-black hover:text-white"
        >

          <FontAwesomeIcon
            icon={faPaperPlane}
            className="mr-3 transition-transform duration-300 group-hover:translate-x-1"
          />

          {loading ? "Sending..." : "Send Inquiry"}

        </button>

      </form>


      {/* Contact */}
      <div className="border-t border-[#ddd7ce] bg-[#8b8172]/30 px-8 py-8">

        <p className="text-center text-xs uppercase tracking-[0.4em] text-[#6d655b]">
          Prefer Direct Contact?
        </p>


        <div className="mt-6 space-y-4">

          <div className="flex items-center justify-center gap-4 text-sm text-[#2b2925]">

            <div className="flex h-10 w-10 items-center justify-center bg-white">
              <FontAwesomeIcon
                icon={faPhone}
                className="text-[#2b2925]"
              />
            </div>

            <span>
              {getCurrentAgentNumber()}
            </span>

          </div>


          <div className="flex items-center justify-center gap-4 text-sm text-[#2b2925]">

            <div className="flex h-10 w-10 items-center justify-center bg-white">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-[#2b2925]"
              />
            </div>

            <span>
              {getCurrentAgentEmail()}
            </span>

          </div>

        </div>

      </div>

    </div>
  );
}
